import React, { createContext, useContext } from 'react';
import { useBranding } from '../hooks/useBranding.js';

const BrandingContext = createContext(null);

/**
 * Branding provider component that wraps the app and provides branding configuration
 */
export const BrandingProvider = ({ children }) => {
  const brandingData = useBranding();

  return (
    <BrandingContext.Provider value={brandingData}>
      {children}
    </BrandingContext.Provider>
  );
};

/**
 * Hook to access branding context from any component
 */
export const useBrandingContext = () => {
  const context = useContext(BrandingContext);

  if (!context) {
    throw new Error('useBrandingContext must be used within a BrandingProvider');
  }

  return context;
};

/**
 * Higher-order component that provides branding context to wrapped component
 */
export const withBranding = (WrappedComponent) => {
  return function BrandingWrappedComponent(props) {
    return (
      <BrandingProvider>
        <WrappedComponent {...props} />
      </BrandingProvider>
    );
  };
};